import type User from 'flarum/common/models/User';

import app from 'flarum/common/app';
import Stream from 'flarum/common/utils/Stream';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export interface IUpdateUserEconomyModalAttrs extends IInternalModalAttrs {
  user: User
}

export default class UpdateUserEconomyModal<CustomAttrs extends IUpdateUserEconomyModalAttrs> extends Modal<CustomAttrs> {
  protected user!: User;
  protected userEconomy: Stream<number>;

  oninit(vnode: any) {
    super.oninit(vnode);

    this.user = this.attrs.user;
    this.userEconomy = Stream(this.user.attribute('money'));
  }

  className(): string {
    return 'UpdateUserEconomyModal';
  }

  content() {
    return <div className="Modal-body">
      <div className="Form-group">
        <label>{app.translator.trans('rhodes-island.lib.economy.update_user_economy')}</label>
        <div>
          <input
            className="FormControl"
            placeholder={app.translator.trans('rhodes-island.forum.economy.user_economy_edit_placeholder')}
            type="number"
            bidi={this.userEconomy}
          />
        </div>
      </div>
      <div className="Form-group">
        <Button className="Button Button--primary" type="submit" loading={this.loading}>
          {app.translator.trans('rhodes-island.lib.economy.user_economy_edit_submit')}
        </Button>
      </div>
    </div>;
  }

  title() {
    return app.translator.trans('rhodes-island.lib.economy.update_user_economy');
  }

  onsubmit(e: SubmitEvent) {
    e.preventDefault();

    this.loading = true;

    const newEconomy = parseInt(this.userEconomy());
    if (isNaN(newEconomy)) {
      this.loading = false;
      return;
    }

    this.user
      .save({
        money: newEconomy
      })
      .then(this.hide.bind(this))
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
